import React, {useState, useEffect, useContext, useRef} from "react";
import {useParams} from "react-router-dom";
import ListPanel from '../administration/components/ListPanel';
import EditPanel from '../administration/components/EditPanel';

import {useHistory} from 'react-router-dom';
import {store} from '../../context/store';
import {INPUT_TYPE_TEXT} from "../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDB} from "../../constants/input-types";
import {functions} from "../../constants/common-functions";
import {STRINGIFY} from "../../constants/general-constants";
import AdminListPanelSpaceTypes from '../administration/components/AdminListPanelSpaceTypes';
import EditButtonPanel from '../administration/components/EditButtonPanel';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";

export default function AdministrationSpaceTypesEdit(){
	
	const globalState = useContext(store);
	const history = useHistory(); 
	const [entityCode, setEntityCode] = useState("");
	const [entityName, setEntityName] = useState("New Space Type");
	
	
	const refCode = useRef(null);
	const refName = useRef(null);
	
	
	const id = useParams()["id"];
	
	useEffect(() => {
		functions.getObjectFromAjax("/resolution/facilityspaceclassificationtype?id=" + id, null, initialiseFields);
	}, [id]);
	
	const getEntityCode = () => {
		return refCode.current.value;
	};
	
	const getEntityName = () => {
		return refName.current.value;
	};
	
	const initialiseFields = (entity) => {
		try{
			setEntityCode(entity.code);
			setEntityName(entity.name);
			refCode.current.value = entity.code;
			refName.current.value = entity.name;
		}
		catch(e){}
		
	};
	
	const mainComponentRows = [
		{ref:refCode, id:"1", title:"Code", inputType:INPUT_TYPE_TEXT},
		{ref:refName, id:"2", title:"Name", inputType:INPUT_TYPE_TEXT},
	];
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	const administrationHeader = {
		display:"flex",
		height:"60px",
		paddingLeft:"20px",
		alignItems:"center",
		color:"black"
	};
	
	const contentPanel = {
		display:"flex",
		width:"100%"
	};
	

	const getSubmitObject = () => {
		let submitObject = {
			id:id,
			code:refCode.current.value,
			name:refName.current.value
		};
		
		return submitObject
	}
	
	const goSubmit = () => {
		
		functions.submitAjax("/resolution/facilityspaceclassificationtypesave", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
		
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		goCancel();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolution/facilityspaceclassificationtypedelete", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	const goCancel = () => {
		history.goBack();
	};

	return (
		
			<div style={thisContainer}>
			<Header/>
				<LeftMenu/>
				<div style={administrationHeader}>
					Space Type Edit: {entityName}
				</div>
				<div style={contentPanel}>
					<EditPanel
					title="Main Details"
						componentRows = {mainComponentRows}
					/>
					<AdminListPanelSpaceTypes
					id={id}
					/>
				</div>
				<EditButtonPanel
					id={id}
					goSubmit={goSubmit}
					goDelete={goDelete}
					goCancel={goCancel}
					checkCodeUrl="facilityspaceclassificationtypes"
					getCodeFunction={getEntityCode}
					getNameFunction={getEntityName}
				/>
			</div>
				
	
	);
}